import {
  PageCollectionConfigLanguage,
  PageFieldsetFieldTypeEnum,
} from '@creator-suite/page-types';

export const getLabelForField = (
  type: PageFieldsetFieldTypeEnum,
  language: PageCollectionConfigLanguage,
) => {
  switch (type) {
    case PageFieldsetFieldTypeEnum.MOBILE_PHONE:
      return language === PageCollectionConfigLanguage.DE
        ? 'Deine Handynummer'
        : 'Your phone number';
    case PageFieldsetFieldTypeEnum.ZIP:
      return language === PageCollectionConfigLanguage.DE ? 'PLZ' : 'Zip';
    case PageFieldsetFieldTypeEnum.EMAIL:
      return language === PageCollectionConfigLanguage.DE ? 'E-Mail' : 'Email';
    case PageFieldsetFieldTypeEnum.CITY:
      return language === PageCollectionConfigLanguage.DE ? 'Stadt' : 'City';
    case PageFieldsetFieldTypeEnum.STREET:
      return language === PageCollectionConfigLanguage.DE ? 'Straße' : 'Street';
    case PageFieldsetFieldTypeEnum.HOUSE_NUMBER:
      return language === PageCollectionConfigLanguage.DE
        ? 'Hausnummer'
        : 'House Number';
    case PageFieldsetFieldTypeEnum.FIRST_NAME:
      return language === PageCollectionConfigLanguage.DE
        ? 'Vorname'
        : 'First Name';
    case PageFieldsetFieldTypeEnum.LAST_NAME:
      return language === PageCollectionConfigLanguage.DE
        ? 'Nachname'
        : 'Last Name';
    default:
      throw new Error('Unknown field type/name.');
  }
};

export const getPlaceholderForField = (
  type: PageFieldsetFieldTypeEnum,
  isOptional: boolean,
  language: PageCollectionConfigLanguage,
) => {
  let placeholder = '';
  switch (type) {
    case PageFieldsetFieldTypeEnum.MOBILE_PHONE:
      placeholder =
        language === PageCollectionConfigLanguage.DE
          ? '+49 176 1234 1234'
          : '+49 176 1234 1234';
      break;
    case PageFieldsetFieldTypeEnum.ZIP:
      placeholder =
        language === PageCollectionConfigLanguage.DE
          ? 'PLZ (Optional)'
          : 'Zip (Optional)';
      break;
    case PageFieldsetFieldTypeEnum.EMAIL:
      placeholder =
        language === PageCollectionConfigLanguage.DE
          ? 'E-Mail (Optional)'
          : 'Email (Optional)';
      break;
    case PageFieldsetFieldTypeEnum.CITY:
      placeholder =
        language === PageCollectionConfigLanguage.DE
          ? 'Stadt (Optional)'
          : 'City (Optional)';
      break;
    case PageFieldsetFieldTypeEnum.STREET:
      placeholder =
        language === PageCollectionConfigLanguage.DE
          ? 'Straße (Optional)'
          : 'Street (Optional)';
      break;
    case PageFieldsetFieldTypeEnum.HOUSE_NUMBER:
      placeholder =
        language === PageCollectionConfigLanguage.DE
          ? 'Hausnummer (Optional)'
          : 'House Number (Optional)';
      break;
    case PageFieldsetFieldTypeEnum.FIRST_NAME:
      placeholder =
        language === PageCollectionConfigLanguage.DE
          ? 'Vorname (Optional)'
          : 'First Name (Optional)';
      break;
    case PageFieldsetFieldTypeEnum.LAST_NAME:
      placeholder =
        language === PageCollectionConfigLanguage.DE
          ? 'Nachname (Optional)'
          : 'Last Name (Optional)';
      break;
    default:
      throw new Error('Unknown field type/name.');
  }

  if (!isOptional) {
    placeholder = placeholder.replace('(Optional)', '');
  }

  return placeholder;
};
